export function LocationButton({ url }: { url: string }) {
  if (!url.trim()) return null;
  return (
    <a
      className="btn btn--primary"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ alignSelf: 'flex-start' }}
    >
      <span aria-hidden="true">📍</span> פתח מיקום במפות
    </a>
  );
}
